<template>
  <b-row v-if="show_layout">
    <div class="position-relative w-100">
      <video class="background-video-proposals" preload="auto" loop="" autoplay="" muted="" playsinline="" v-if="!is_whitelabel">
        <source :src="require('@/assets/images/dashboard/proposals/background-home-proposals.mp4')">
      </video>
      <shimmer-preview v-else></shimmer-preview>
      <div class="landing-cover mt-3">
        <div class="d-flex flex-column align-items-center">
          <h3 class="text-title fw-semi-bold text-white text-center mb-5 mb-sm-4 mx-2">
            <transition name="fade">
              <span :key="current_word" class="position-relative">
                <span>
                  {{ words_main_titles[current_word] }} 
                </span>
              </span>
            </transition>
            {{ $t('creator.hireCreators') }}
          </h3>
          <div class="position-relative container-search w-100 d-flex justify-content-center position-relative">
            <div class="position-relative container-inner">
              <b-form-input
                class="input-search-proposal"
                :placeholder="searchPlaceholder"
                v-model="search"
                @keyup.enter="searchQuery()"
                trim
                @focus="focusActionInput"
                @blur="blurActionInput"
                autocomplete="off"
              > 
              </b-form-input>
              <b-icon
                class="icon-search"
                icon="search"
                @click="searchQuery"
              ></b-icon>
              <suggestions-container 
                :show_suggestions="show_suggestions"
                :key="update_suggestions"
                :list_selected="button_Selected"
              />
            </div>
          </div>
          <div>
            <b-button pill class="button-create avenir-medium" variant="button-create" @click="$router.push({name: 'pages-account-setting', params: { section: 'membership' } })">
              {{ $t('creator.createPro') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <b-row class="m-0 p-1 p-md-3 mx-auto container-results-proposals w-100">
      <div class="container-loader-searcher loader-table-cards" v-if="!loaded">
      <b-spinner class="spinner-table-searcher"></b-spinner>
    </div>
      <b-col class="w-100">
        <div class="w-100 d-flex justify-content-between">
          <span class="text-proposals">{{ $t('creator.proposalsFeatured') }}</span>
          <b-link @click="$router.push({name: 'creadores'})">
            <span class="avenir-medium">{{ $t('creator.viewAlls') }}</span>
          </b-link>
        </div>

        <component :is="vue_horizontal" responsive class="horizontal my-2" :displacement="0.3" snap="center" v-if="loaded && vue_horizontal">
          <card-category
            v-for="(item, index) in results" :key="index"
            :proposal="item"
            :width="'300px'"
            :countries="countries"
            class="mr-1"
          />
        </component>
      </b-col>
      <b-col class="col-12">
        <div class="mb-2">
          <span class="text-proposals">{{ $t('creator.proposalsBynet') }}</span>
        </div>
        <div class="network-grid" v-if="loaded">
          <card-network v-for="(item, index) in network"
            :key="index"
            :net="item"
            :icon="getIconWhite(item)"
            :img="getUrlCategory(item)"
            :featured="index === 0"
          />
        </div>
      </b-col>
      <b-col class="col-12 mb-2">
        <brandme-ia-banner v-if="loaded"></brandme-ia-banner>
      </b-col>

      <b-col class="col-12 px-1 mb-2">
        <div class="box-casting-calls">
          <div class="col-12 col-md-3 mb-1 mb-md-0">
            <h1>{{ $t('dashboard.campaigns') }}</h1>
            <p class="avenir-medium">{{ $t('creator.wantWork') }}</p>
            <b-button variant="light" class="avenir-medium" @click="$router.push({name: 'marcas'})">{{ $t('creator.viewMore') }}</b-button>
          </div>
          <div class="col-12 col-md-9">
            <component :is="vue_horizontal" responsive class="horizontal horizontal-gray-casting-calls" :displacement="0.3" snap="end" v-if="loaded_casting_calls">
              <card-casting-call v-for="casting_call in casting_calls" :key="casting_call.uuid" :casting_call="casting_call"></card-casting-call>
            </component>
          </div>
        </div>
      </b-col>
      <b-col class="col-12 px-1">
        <b-row class="w-100 m-0">
          <card-marketing class="col-12 col-lg-6 p-0 pr-lg-1 mb-2 mb-lg-0"
            :textBadge="$t('creator.marketingSoftware')"
            :textInfo="$t('creator.manageAll')"
            :textButton="$t('creator.getStarted')"
            :textLink="$t('creator.findAbout')"
            :img="getUrlCategory('pinterest')"
            :reference="'https://brandme.la/solicitar-propuesta/'"
            :reference_link="'https://brandme.la/solicitar-propuesta/'"
          >
          </card-marketing>
          
          <card-marketing class="col-12 col-lg-6 p-0 pl-lg-1"
            :colorCard="'card-secondary'"
            :textBadge="$t('creator.fullService')"
            :textInfo="$t('creator.strategyNeed')"
            :textButton="$t('creator.requestProposals')"
            :textLink="$t('creator.learMore')"
            :link="$t('creator.managedService')"
            :img="getUrlCategory('food')"
            :reference="'https://brandme.la/solicitar-propuesta/'"
            :reference_link="'https://brandme.la/solicitar-propuesta/'"
          >
          </card-marketing>
        </b-row>
      </b-col>
    </b-row>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BIcon,
  BButton,
  BLink,
  BSpinner,
} from "bootstrap-vue";
import cardCategory from "@/views/pages/proposals/cardCategory.vue";
import cardCastingCall from '@/views/components/casting-calls/cardCastingCall.vue';
import cardNetwork from "@/views/pages/proposals/cardNetwork.vue";
import { getIconWhite } from '@/libs/utils/icons';
import { getUserData } from '@/libs/utils/user';
import { getMotivationalPhrase, getCountries } from '@/libs/utils/others';
import { getUrlCategory } from '@/libs/utils/urls';

import { proposalsRepository } from "@/infrastructure/proposals/proposals.repository";
import { castingCallsRepository } from "@/infrastructure/castingCalls/castingCalls.repository";
import { makeLoadHomeDataUseCase } from "@/application/home/loadHomeData.usecase";
import { makeSubmitHomeSearchUseCase } from "@/application/search/submitHomeSearch.usecase";
import { createNavbarHomeSetupEffect } from "@/ui/effects/navbarHomeSetup.effect";
import { createNavbarTransparentEffect } from "@/ui/effects/createNavbarTransparent.effect";
import { createVsLoadingEffect } from "@/ui/effects/vsLoading.effect";
import { hasAccessToPremiumFeatures } from '@/domain/user/access.domain';

export default {
  components: {
    BSpinner,
    BIcon,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    cardCategory,
    cardCastingCall,
    cardNetwork,
    cardMarketing: () => import('@/views/components/proposals/cardMarketing.vue'),
    suggestionsContainer: () => import('@/views/components/proposals/suggestionsContainer.vue'),
    BrandmeIaBanner: () => import('@/views/components/banner/BrandmeIaBanner.vue'),
    shimmerPreview: () => import('@/views/pages/proposals/shimmer-preview.vue'),
  },
  data() {
    return {
      countries: getCountries(),
      words_main_titles: [this.$t('creator.pioner'), this.$t('creator.experts'), this.$t('creator.leader')],
      current_word: 0,
      interval_word: null,
      interval_loading: null,
      search: "",
      results: [],
      network: ['youtube', 'tiktok', 'instagram','facebook','linkedin','twitch','twitter','spotify','pinterest','blog','snapchat'],
      show_layout: false,
      show_suggestions: false,
      update_suggestions: false,
      casting_calls: [],
      loaded: false,
      loaded_casting_calls: false,
      user_data: getUserData(),
      button_Selected: {
        selected: false,
        type_button: '',
        list_button: [],
      },
      vue_horizontal: null,
      navbarTransparentEffect: null,
      navbarHomeSetupEffect: null,
      vsLoadingEffect: null,
      submitHomeSearch: null,
    };
  },
  computed: {
    has_a_plan_or_is_creator() {
      return hasAccessToPremiumFeatures(this.user_data);
    },
    is_whitelabel() {
      return false;
    },
    searchPlaceholder() {
      if (!this.user_data) {
        return this.$t('creator.placeholder_suggestions_brand');
      }
      
      return this.user_data.main_group?.name === 'creator' ? this.$t('creator.placeholder_suggestions_creator') : this.$t('creator.placeholder_suggestions_brand');
    }
  },
  created() {
    this.vsLoadingEffect = createVsLoadingEffect({
      vs: this.$vs,
      getMotivationalPhrase,
    });
    this.vsLoadingEffect.start();
  },
  async mounted() {
    this.navbarHomeSetupEffect = createNavbarHomeSetupEffect({ store: this.$store });
    this.navbarHomeSetupEffect.mount();
  
    this.navbarTransparentEffect = createNavbarTransparentEffect();
    this.navbarTransparentEffect.mount();

    this.vue_horizontal = (await import("vue-horizontal")).default;

    const loadHomeData = makeLoadHomeDataUseCase({
      proposalsRepo: proposalsRepository,
      castingCallsRepo: castingCallsRepository,
    });

    this.submitHomeSearch = makeSubmitHomeSearchUseCase({ getUserData });

    try {
      const { proposals, castingCalls } = await loadHomeData();
      this.results = proposals;
      this.casting_calls = castingCalls;
      this.loaded = true;
      this.loaded_casting_calls = true;
    } catch (error) {
      this.results = [];
      this.casting_calls = [];
      this.loaded = true;
      this.loaded_casting_calls = true;
    } finally {
      if (this.vsLoadingEffect) this.vsLoadingEffect.stop();
      this.show_layout = true;
    }
  },

  destroyed() {
    if (this.navbarHomeSetupEffect) {
      this.navbarHomeSetupEffect.unmount();
    }
    if (this.navbarTransparentEffect) {
      this.navbarTransparentEffect.unmount();
    }
    if (this.vsLoadingEffect) {
      this.vsLoadingEffect.stop();
    }
  },
  methods: {
    getUrlCategory,
    getIconWhite,
    focusActionInput() {
      if (this.has_a_plan_or_is_creator) {
        this.show_suggestions = true; 
        this.update_suggestions = !this.update_suggestions;
      }
    },
    searchQuery() {
      this.submitHomeSearch({
        search: this.search,
        router: this.$router,
        emit: this.$root.$emit.bind(this.$root),
      });
    },
    blurActionInput() {
      if (this.has_a_plan_or_is_creator) {
        setTimeout(() => {        
          this.show_suggestions = false;
          this.update_suggestions = !this.update_suggestions;
        }, 1000);
      }
    },
  },
};
</script>
<style>
.tranparent-background-nav {
  background: none !important;
  background-color: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
.in-animation-nav {
  animation: nav-animation 1s;
}
.out-animation-nav {
  animation: nav-animation-2 1s;
}
@keyframes nav-animation {
  0% { transform: translateY(0px);}
  50% {transform: translateY(-100px);}
  100% {transform: translateY(0px);}
}
@keyframes nav-animation-2 {
  0% { transform: translateY(0px);}
  50% {transform: translateY(-100px);}
  100% {transform: translateY(0px);}
}
.leave {
  position: absolute;
}
</style>
<style scoped lang="scss">
.network-grid {
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-auto-flow: column;
  grid-auto-columns: 250px;
  gap: 1rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
}
.fade-leave-active {
  position: absolute;
  transition: opacity 0.4s;
}

.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.4s;
}

.fade-enter {
  opacity: 0;
}
.container-loader-searcher {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255);
  z-index: 1000;
  right: 5px;
}
.loader-table-cards {
  z-index: 10;
  display: flex;
  justify-content: center;
}
.spinner-table-searcher {
  margin-top: 4em;
  height: 6em;
  width: 6em;
  color: #acacac;
}
.box-casting-calls {
  background-color: #ececec;
  padding: 2em;
  border-radius: 1em;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.horizontal >>> .v-hl-btn svg {
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 8px !important;
  height: 100% !important;
  box-shadow: none !important;
  background: none !important;
}

.horizontal >>> .v-hl-btn-prev {
  background: linear-gradient(to left, #ffffff00 0, white 66%, white) !important;
  padding-right: 24px !important;
}

.horizontal >>> .v-hl-btn-next {
  background: linear-gradient(to right, #ffffff00 0, white 66%, white) !important;
  padding-left: 24px !important;
}
.horizontal-gray-casting-calls  >>> .v-hl-btn-prev {
  background: linear-gradient(to right, #ececec 0, #ffffff00 66%, #ffffff00) !important;
}
.horizontal-gray-casting-calls  >>> .v-hl-btn-next {
  background: linear-gradient(to right, #ffffff00 0, #ececec 66%, #ececec) !important;
}
.horizontal >>> .v-hl-btn {
  top: 0 !important;
  bottom: 0 !important;
  transform: translateX(0) !important;
}
.link-view-all {
  font-weight: 400;
  color: #55a6c4 !important;
}
.text-proposals {
  font-size: 1.3rem;
  line-height: 1.2;
}
.container-proposals {
  display: flex;
  justify-content: space-between !important;
  margin: 67px 10px 10px 8px;
}
.container-cards {
  display: flex;
  justify-content: space-between !important;
}
.button-create {
  margin: 22px;
  background: rgba(248, 249, 250, 0.2) !important;
  color: #f8f9fa;
}
.button-create:hover {
  margin: 22px;
  background: rgba(248, 249, 250, 0.792) !important;
}
.icon-search {
  position: absolute;
  color: #6c757d;
  z-index: 8;
  left: 0em;
  top: 0.05em;
  font-size: 40px;
  cursor: pointer;
  padding: 8px;
}
.container-search {
  .container-inner {
    @media(max-width: 615px) {
      width: 100%;
    }
    .input-search-proposal { 
      border-radius: 1.357rem;
      padding-left: 40px;
      width: 550px;
      height: 45px;
  
      @media(max-width: 615px) {
        width: 100%;
      }
    }
  
  }
  @media(max-width: 615px) {
    padding: 0 3em;
  }
}
.text-title {
  position: relative;
  font-size: calc(1.409375rem + 1.9125vw);
  font-weight: bold;
  line-height: 1.2;
}
.landing-cover {  
  position: absolute;
  top: 8.5rem;
  width: 100%;
  background: transparent;
}
.background-video-proposals {
  width: 100%;
  height: 440px;
  object-fit: fill;
}
 @media (max-width: 459px) {
 .container-cards { 
   justify-content: center !important;
  }
 }

.container-results-proposals {
  max-width: 1440px;
}
</style>